/** zh-CN catalogue `time` (W3-09; English: src/core/time/time.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'time',
  locale: 'zh-CN',
  messages: {
    'parse.empty': '请输入拍数，例如 12:3/4',
    'parse.incomplete': '末尾缺少内容，例如 12:3/4',
    'parse.unexpected': '第 {pos} 个字符处出现意外的“{char}”',
    'parse.expectedNumber': '第 {pos} 个字符处应为数字',
    'parse.expectedFraction': '第 {pos} 个字符处应为分数，例如 3/4',
    'parse.zeroDenominator': '分数的分母不能为 0',
    'parse.decimalInFraction': '分数只能使用整数：请写 3/4，而不是 1.5/2',
    'parse.tooLarge': '此拍数超出范围',
    'parse.tooPrecise': '精度过高：请使用更简单的分数或更少的小数位',
    'parse.needsSnap': '12;1 这类步进需要设置节拍吸附；请先选择吸附',
    'parse.needsSnapDecimal': '在 RPE 写法中，12.1 表示第 12 拍再加一个吸附步长；请先选择节拍吸附',
    'parse.needsTempo': '此处不能使用秒；请输入拍数，例如 12:3/4',
    'parse.badTime': '此时间超出了速度表的范围',
    'parse.mixedUnits': '秒和拍不能混用，请只用其中一种',
    'parse.clockRange': '此处的分和秒必须小于 60（第 {pos} 个字符）',
    'parse.atFirst': '请把“@”放在开头，例如 @37:1/4 或 @1:23.5',
    'parse.noMarkers': '此处不能使用标记',
    'parse.unknownMarker': '没有名为“{name}”的标记',
    'parse.markerName': '请在“{prefix}”后输入标记名称',
    'parse.markerFirst': '请把标记放在最前面，例如 m12+2',
    'parse.unclosedQuote': '请用引号（"）结束标记名称',
    barBeat: '第 {bar} 小节 . 第 {beat} 拍{frac}',
  },
};

export default catalog;
